import React from "react";

import { Table, Pagination } from "clearsense-ui/components";
import { Edit, Delete } from "clearsense-ui/icons";
import PermissibleWrapper from "components/Common/PermissibleWrapper";
import formatPermissions from "utils/formatPermissions";

import {
  SURVIVORSHIP_DOMAIN_BUSINESS_RULES_COLUMNS,
  PAGE_SIZE_OPTIONS,
} from "../../../constants";

const DetailsTable = ({
  isLoading,
  rules,
  userPermissions,
  handleEditClick,
  setDeleteRule,
  handleTableChange,
  paginationProps,
}) => {
  const { currentPage, pageSize, setCurrentPage, setPageSize, recordsCount } =
    paginationProps;

  return (
    <>
      <Table
        fixedHeight
        allowRowClick={false}
        rowSelection={false}
        scroll={{ x: false }}
        columnData={[
          ...SURVIVORSHIP_DOMAIN_BUSINESS_RULES_COLUMNS,
          ...(formatPermissions(userPermissions)
            ?.map(permission =>
              formatPermissions(["update", "destroy"])?.includes(permission)
            )
            ?.includes(true) ||
          userPermissions?.includes("all") ||
          userPermissions === "all"
            ? [
                {
                  key: "Actions",
                  width: 80,
                  align: "center",
                  fixed: "right",
                  render: (_, record) => (
                    <div className="flex space-x-3 justify-center">
                      <PermissibleWrapper
                        currentPermissions={userPermissions}
                        acceptablePermissions="update"
                      >
                        <Edit
                          size={20}
                          className="flex-shrink-0 cursor-pointer hover:text-primary-shade"
                          onClick={() => handleEditClick(record)}
                        />
                      </PermissibleWrapper>
                      <PermissibleWrapper
                        currentPermissions={userPermissions}
                        acceptablePermissions="destroy"
                      >
                        <Delete
                          size={20}
                          className="flex-shrink-0 cursor-pointer hover:text-red-500"
                          onClick={() =>
                            setDeleteRule(record.business_rule_number)
                          }
                        />
                      </PermissibleWrapper>
                    </div>
                  ),
                },
              ]
            : []),
        ]}
        rowData={rules.map(filteredRule => ({
          key: filteredRule.id,
          ...filteredRule,
        }))}
        loading={isLoading}
        onChange={(_pagination, _filters, sorter) => handleTableChange(sorter)}
      />
      <Pagination
        showResultsPerPage
        currentPage={currentPage}
        pageSize={pageSize}
        totalRecordsCount={recordsCount}
        setCurrentPage={setCurrentPage}
        setPageSize={setPageSize}
        pageSizeOptionsList={PAGE_SIZE_OPTIONS}
        className="cs-ui-table-background"
      />
    </>
  );
};

export default DetailsTable;
